<template>
  <div class="enrollInputImgWrapper">
    <input ref="imageInput" type="file" hidden v-on:change="onChangeImages">
    <img class="enrollInputImg" v-bind:src="imageUrl">
    <div class="overlayImgWrapper">
      <img class="overlayImg" v-bind:src="iconUrl" v-on:click="onClickIcon">
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isImageSet: false,
      imageUrl: '',
      iconUrl: require('@/assets/img/add_image_icon.png')
    }
  },
  methods: {
    onClickIcon () {
      if(!this.isImageSet) {
        this.$refs.imageInput.click()
      }else{
        this.iconUrl = require('@/assets/img/add_image_icon.png')
        this.setCanvas(require('@/assets/img/question_title_default_img.png'), false)
        this.setImageInfoStore(null)
        this.$refs.imageInput.value = null
      }
    },
    onChangeImages (e) {
      let pathPoint = e.target.files[0].name.lastIndexOf('.')
      let fileType = e.target.files[0].name.substring(pathPoint + 1, e.target.files[0].name.length).toLowerCase()

      if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'gif' || fileType === 'png' || fileType === 'bmp' || fileType === '') {
        const file = e.target.files[0]
        this.setCanvas(file, true)
        this.setImageInfoStore(file)
      }else {
        this.setCanvas(require('@/assets/img/question_title_default_img.png'), false)
        this.setImageInfoStore(null)
        alert('이미지 파일을 선택 해 주세요.')
      }
    },
    setCanvas (fileOrImageUrl, isImageSet) {
      // 캔버스에 이미지 셋팅
      this.imageUrl = fileOrImageUrl instanceof File ? URL.createObjectURL(fileOrImageUrl) : fileOrImageUrl
      this.isImageSet = isImageSet
    },
    setImageInfoStore (file) {
      // enrollstate, AduiState에 저장
      this.$store.commit('setEnrollStateValue', {type: 'titleImg', value: file})
      this.$store.commit('setAdUiStateValue', {type: 'titleImg', value: file != null ? URL.createObjectURL(file) : null})
    }
  },
  created: function () {
    // 기존에 EnrollState에 지정된 이미지(url)이 있을 경우 이미지 불러옴
    let beforeImg = this.$store.getters.getEnrollStateValue('titleImg')
    beforeImg != null ? this.setCanvas(beforeImg, true) : this.setCanvas(require('@/assets/img/question_title_default_img.png'), false)
  },
  watch: {
    isImageSet: function () {
      this.iconUrl = this.isImageSet ? require('@/assets/img/remove_image_icon.png') : require('@/assets/img/add_image_icon.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0;
  font-size: 22px;
  width: 100%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

span {
  font-size: 12px;
}

.enrollInputImgWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.enrollInputImg{
  width: 100%;
  height: 100%;
}

.overlayImgWrapper{
  position: absolute;
  top: calc(100% - 18px);
  left: calc(100% - 18px);
}

.overlayImg{
  cursor: pointer;
  width: 24px;
  height: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollInputImgTitle.vue